export const REQUEST_FORM_URL_FALLBACK = 'https://my.cian.ru/deal-sale-form/';
export const DEAL_PROCESS_VIDEO_IFRAME_URL_FALLBACK = 'https://www.youtube.com/embed/XPWB7sURxf0';
export const DEAL_SALE_B2B_PROMO_URL_FALLBACK = 'https://www.cian.ru/registraciya-prava-sobstvennosti-na-nedvizhimost/';
